import { DynamicPricesContext } from 'contexts/providers/DynamicPricesProvider'
import { useContext } from 'react'

export function useDynamicPrices() {
  return useContext(DynamicPricesContext)
}
